<template>
  <div class="container">
    <div v-html="intro"></div></div>
    
</template>

<script>
import { agree } from '../api/api';
export default {
   name: 'jobintro',
 data() {
    return {
       intro:""
    }
  },
  mounted() {
   agree({
        id: 1
      }).then(res => {
        if (res.data.code == 200) {

          this.intro= res.data.result.content;
        }
      });
  }
}
</script>

<style lang="scss" scoped>
.container {
  margin-top: 10px;
  padding: 30px
}
</style>
 


// WEBPACK FOOTER //
// src/components/jobintro.vue